import {
  Component,
  ViewChild,
  Input,
  EventEmitter,
  Output,
  OnChanges,
  SimpleChanges,
  ElementRef,
  TemplateRef,
} from '@angular/core';
import { BaseComponent } from '@shared/components/base-component/base.component';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { LocationModel } from '@features/live-tracking/models/location.model';
import { MatSort } from '@angular/material/sort';
import { AddLocationType } from '@features/customers/enums/add-location-type.enum';
import { SectionStateStatus } from '@shared/enums/section-state-status.enum';
import { LocationType } from '@shared/enums/location-type.enum';
import { SharedConstants } from '@shared/model/shared-constants';
import { RolesConstants } from '@shared/model/roles-constants';
import { LocationsApiService } from '@shared-features/services/locations-api.service';
import { takeUntil } from 'rxjs/operators';
import { RoutesUtil } from '@shared-features/utils/routes.util';
import { LocationStatus } from '@shared-features/enums/location-status.enum';
import { DialogLayoutComponent } from '@shared/components/dialog-layout/dialog-layout.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-locations-list',
  templateUrl: './locations-list.component.html',
  styleUrls: ['./locations-list.component.scss'],
})
export class LocationsListComponent extends BaseComponent implements OnChanges {
  dataSource: MatTableDataSource<LocationModel> = new MatTableDataSource();
  displayedColumns: string[] = [
    // 'type',
    'defaultIcon',
    'locationName',
    'city',
    'shipment',
    'status',
    'Latitude&Longitude',
    'address',
    'shippingType',
    'contacts',
    'reference',
    'action',
  ];
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @Input() item: any;
  @Input() locations: LocationModel[] = [];
  @Input() type: LocationType;
  @Input() cancelAddMoreLocations: boolean = false;
  @Input() showAddLocationTypeColumn: boolean = false;
  @Input() readOnly = false;
  @Output() navigateToMap = new EventEmitter();
  @Output() locationId = new EventEmitter();
  @Output() reload = new EventEmitter();
  @Output() addMoreLocations = new EventEmitter();

  location: LocationModel;
  selectedLocation: LocationModel = new LocationModel();
  RolesConstants = RolesConstants;
  LocationType = LocationType;
  sectionState: SectionStateStatus;
  sectionStateStatus = SectionStateStatus;
  sharedConstants = SharedConstants;
  latitude: number = null;
  longitude: number = null;
  totalRowsCount: number;
  LocationStatus = LocationStatus;
  @ViewChild('addLocationModal') addLocationModal: TemplateRef<DialogLayoutComponent>;
  AddLocationType = AddLocationType;
  RoutesUtil = RoutesUtil;

  @ViewChild('toolTipContacts') toolTipContacts: ElementRef;

  constructor(
    private locationsApiService: LocationsApiService,
    public matDialog: MatDialog
  ) {
    super();
  }

  ngOnInit(): void {
    this.filters.params = { offset: 0 };
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.locations && changes.locations.currentValue !== changes.locations.previousValue) {
      this.locations = changes.locations.currentValue || [];
      if (!changes.item?.firstChange) {
        if (!this.locations.length) {
          this.sectionState = SectionStateStatus.Empty;
        } else {
          this.sectionState = SectionStateStatus.Ready;
        }
      }
      this.setupTable(this.locations);
    }
    if (
      changes.selectedLocation &&
      changes.selectedLocation.currentValue !== changes.selectedLocation.previousValue
    ) {
      this.locations.forEach((location) => (location.selected = false));
      this.selectedLocation.selected = true;
      this.changeLocation(this.selectedLocation.latitude, this.selectedLocation.longitude);
    }
  }

  private setupTable(locations: LocationModel[]) {
    this.filters.data$;
    this.locations = locations;
    this.filters.data$.pipe(takeUntil(this.destroy$)).subscribe(({ offset, limit }) => {
      this.dataSource.data = (this.locations || []).slice(offset * limit, (offset + 1) * limit);
      this.dataSource.sort = this.sort;
      this.totalRowsCount = this.locations.length;
    });
  }

  onNavigateToMap(location) {
    this.navigateToMap.emit(location);
    this.onSelectLocation(location);
  }

  showAllContacts() {
    this.toolTipContacts.nativeElement.style.display = 'inline-block';
  }

  onSetAsDefault(location: LocationModel) {
    this.selectedLocation = location;

    const body: Partial<LocationModel> = {
      isDefault: true,
      id: location.id,
      shippingType: location.shippingType,
    };

    this.load(this.locationsApiService.editLocation(body)).subscribe((location) => {
      this.locations.forEach((location) => (location.isDefault = false));
      this.selectedLocation.isDefault = location?.isDefault;
    });
  }

  onChangeStatus(location: LocationModel) {
    location.status =
      location.status === LocationStatus.Active ? LocationStatus.Inactive : LocationStatus.Active;

    const body: Partial<LocationModel> = {
      status: location.status,
      id: location.id,
      shippingType: location.shippingType,
    };

    this.load(this.locationsApiService.editLocation(body), {
      fetchOnce: true,
    }).subscribe(() => {
      this.showSuccessMessage('SuccessMessages.LocationModifiedSuccessfully');
    });
  }

  onSelectLocation(item: LocationModel) {
    this.locations.forEach((location) => (location.selected = false));
    this.selectedLocation = item;
    item.selected = true;
    this.changeLocation(item.latitude, item.longitude);
  }

  private changeLocation(lat, lng) {
    this.latitude = lat;
    this.longitude = lng;
  }

  onUpdateLocation(event) {
    this.selectedLocation = event;
    this.locations.some((location) => {
      if (location.id === event.id) {
        location.city = event.city;
        return true;
      }
    });
  }

  onAddLocation(id: number) {
    this.locationId.emit(id);
  }

  onAddMoreLocations() {
    if (this.cancelAddMoreLocations) {
      this.addMoreLocations.emit();
    } else {
      this.selectedLocation = {} as any;
      this.matDialog.open(this.addLocationModal);
    }
  }
}
